import React, { useState, useRef, useEffect } from 'react';

const EditDropdown = ({ onEditContact }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (editType) => {
    onEditContact(editType);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '10px 18px',
          background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 2px 4px rgba(5, 150, 105, 0.3)'
        }}
        onMouseOver={(e) => {
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 8px rgba(5, 150, 105, 0.4)';
        }}
        onMouseOut={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(5, 150, 105, 0.3)';
        }}
      >
        <i className="fas fa-edit"></i>
        Edit Contact
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`} style={{ fontSize: '12px' }}></i>
      </button>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          backgroundColor: 'white',
          border: '1px solid #e9ecef',
          borderRadius: '12px',
          boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
          zIndex: 1000,
          minWidth: '220px',
          marginTop: '8px',
          overflow: 'hidden'
        }}>
          <button
            onClick={() => handleOptionClick('primary')}
            style={{
              width: '100%',
              padding: '14px 18px',
              backgroundColor: 'transparent',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#212529',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.paddingLeft = '22px';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.paddingLeft = '18px';
            }}
          >
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              backgroundColor: '#fff3e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <i className="fas fa-user" style={{ color: '#f57c00', fontSize: '14px' }}></i>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '2px' }}>Edit Primary Contact</div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>Update main email and phone</div>
            </div>
          </button>

          <div style={{ height: '1px', backgroundColor: '#f1f3f4', margin: '0 12px' }}></div>

          <button
            onClick={() => handleOptionClick('alternative')}
            style={{
              width: '100%',
              padding: '14px 18px',
              backgroundColor: 'transparent',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#212529',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.paddingLeft = '22px';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.paddingLeft = '18px';
            }}
          >
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              backgroundColor: '#e3f2fd',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <i className="fas fa-plus-circle" style={{ color: '#1976d2', fontSize: '14px' }}></i>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '2px' }}>Edit Alternative Contact</div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>Update backup contact info</div>
            </div>
          </button>

          <div style={{ height: '1px', backgroundColor: '#f1f3f4', margin: '0 12px' }}></div>

          <button
            onClick={() => handleOptionClick('all')}
            style={{
              width: '100%',
              padding: '14px 18px',
              backgroundColor: 'transparent',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#212529',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              transition: 'all 0.2s ease',
              fontWeight: '500'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.paddingLeft = '22px';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.paddingLeft = '18px';
            }}
          >
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              backgroundColor: '#f3e5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <i className="fas fa-edit" style={{ color: '#6f42c1', fontSize: '14px' }}></i>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '2px' }}>Edit All Contact Info</div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>Update all contact details</div>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default EditDropdown;